import { AuthService } from '../../services/auth.service';

import {
  Component,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  ViewChildren,
  QueryList,
  viewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OpanaiService } from '../../services/openai.service';
import { MarkdownViewerComponent } from '../../shared/markdown-viewer/markdown-viewer.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import {
  ModuleService,
  AssistantDataItem,
  InitializedItem,
  InitMenuItem,
} from '../../services/modules.service';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';

import { EnvironmentService } from '../../services/enviroment.service';
import { environment } from '../../services/global-environment';

import { Renderer2, ElementRef, AfterViewInit } from '@angular/core';

import { COMPONENT_MAP } from '../../conponents/component-map'; //元件的對應表
import { ignoreElements } from 'rxjs';

import { AzureBlobService } from '../../services/azure-blob.service';
import { MenuService, MenuButton } from '../../services/MenuService';
import { FilebankComponent } from '../filebank/filebank.component';

import { EventEmitter } from '@angular/core';

import { ComponentMappingService } from '../../services/component-mapping.service';
import { ComponentMapping } from '../../models/component-map.model';
import { HttpClient } from '@angular/common/http';

import jsQR from 'jsqr'; // 使用 jsQR 來解析 QR Code
import { I18nService } from '../../services/i18n.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

// API 回應介面
interface UserRoleApiResponse {
  success: boolean;
  data: string[];
}

interface Button {
  icon?: string; // 按鈕的圖標
  text?: string; // 按鈕的文字
  action?: () => void; // 按鈕的點擊行為
  tooltip?: string; // 提示文字
}

interface Annotation {
  index: number;
  type: string;
  text: string;
  start_index: number;
  end_index: number;
  file_citation: {
    file_id: string;
    quote: string;
  };
  filename: string;
  fileurl: string;
  filepage: string;
}

type ShowTarget = 'chat' | 'file' | 'form' | 'report' | 'todo' | 'page';

@Component({
  selector: 'app-assistant',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MarkdownViewerComponent,
    TranslatePipe,
    // FilebankComponent,
  ],
  templateUrl: './assistant.component.html',
  styleUrl: './assistant.component.scss',
})
export class AssistantComponent implements OnInit {
  @ViewChild('filebankcontainer', { read: ViewContainerRef })
  filebankcontainer!: ViewContainerRef;

  // 檔案選擇區塊狀態
  isFilePickerActive: boolean = false;
  // 檔案選擇 modal 狀態（已廢棄）
  fileModalVisible: boolean = false;
  fileList: any[] = [];
  fileTagFilter: string = '';
  fileSelectedFiles: any[] = [];

  // 取得所有出現過的 tags（去重）
  get allFileTags(): string[] {
    const tagSet = new Set<string>();
    this.fileList.forEach(file => {
      if (Array.isArray(file.tags)) {
        file.tags.forEach((tag: string) => tagSet.add(tag));
      }
    });
    return Array.from(tagSet);
  }

  // 依 fileTagFilter 篩選 fileList
  get filteredFileList(): any[] {
    if (!this.fileTagFilter) return this.fileList;
    const filter = this.fileTagFilter.toLowerCase();
    return this.fileList.filter(file =>
      (file.filename && file.filename.toLowerCase().includes(filter)) ||
      (Array.isArray(file.tags) && file.tags.some((tag: string) => tag.toLowerCase().includes(filter)))
    );
  }

  toggleFilePicker() {
    // 互斥：關閉其他兩個 active 狀態
    if (!this.isFilePickerActive) {
      this.isWebSearchActive = false;
      this.isFileSearchActive = false;
      // 切換到 file picker 時，清除其他功能的狀態
    }
    this.isFilePickerActive = !this.isFilePickerActive;
    if (this.isFilePickerActive) {
      this.loadFileList();
    } else {
      this.clearFilePickerState();
    }
  }

  // 清除檔案選擇區塊狀態
  clearFilePickerState() {
    this.isFilePickerActive = false;
    this.fileTagFilter = '';
    this.fileSelectedFiles = [];
    this.selectedFileIds = [];
  }

  closeFilePicker() {
    this.isFilePickerActive = false;
    this.fileTagFilter = '';
    this.fileSelectedFiles = [];
  }

  // 保留 modal 相關方法（不再使用）
  openFileModal() {
    this.fileModalVisible = true;
    this.loadFileList();
  }
  closeFileModal() {
    this.fileModalVisible = false;
    this.fileTagFilter = '';
    this.fileSelectedFiles = [];
  }

  toggleFileSelection(file: any) {
    const idx = this.fileSelectedFiles.findIndex(f => f.id === file.id);
    if (idx > -1) {
      this.fileSelectedFiles.splice(idx, 1);
    } else {
      this.fileSelectedFiles.push(file);
    }
    // Keep selectedFileIds in sync with fileSelectedFiles
    this.selectedFileIds = this.fileSelectedFiles.map(f => f.id);
  }

  isFileSelected(file: any): boolean {
    return this.fileSelectedFiles.some(f => f.id === file.id);
  }

  insertSelectedFilesToMessage() {
    if (this.fileSelectedFiles.length === 0) return;
    const tags = this.fileSelectedFiles.map(f => `<span class="file-tag">#${f.filename}</span>`).join(' ');
    this.userMessage = (this.userMessage || '') + ' ' + tags;
    this.closeFileModal();
  }

  // 載入檔案列表（複用 filebank 的 getfillist）
  // 取得檔案額外資訊
  getFilesExtraInfo(companyid: string, vectorStoreId: string) {
    this.openAiApiService.getFilesExtraInfo(companyid, vectorStoreId).subscribe((response) => {
      if (response.success && response.items && response.items.length > 0) {
        this.updateFileListWithExtraInfo(response.items);
      }
    });
  }

  // 合併額外資訊到 fileList
  updateFileListWithExtraInfo(extraInfoItems: any[]) {
    const extraInfoMap = new Map();
    extraInfoItems.forEach(item => {
      extraInfoMap.set(item.fileid, item);
    });

    this.fileList.forEach(file => {
      const extraInfo = extraInfoMap.get(file.id);
      if (extraInfo) {
        file.azureUrl = extraInfo.azureUrl;
        if (extraInfo.tags && extraInfo.tags.length > 0 && (!file.tags || file.tags.length === 0)) {
          file.tags = extraInfo.tags;
        }
      }
    });
  }

  loadFileList() {
    if (!this.vector_store_id) return;
    this.openAiApiService.getfilelist(this.vector_store_id).subscribe((response) => {
      this.fileList = response.files.map((file: any) => ({
        ...file,
        tags: Array.isArray(file.tags) ? file.tags : []
      }));
      // 取得並合併額外資訊
      this.getFilesExtraInfo(this.companyid, this.vector_store_id);
    });
  }

  componentMappings: ComponentMapping[] = [];

  showintroduction = true;
  showrecommentlist = true;

  //設定是否要開啟steam
  withstram = true;

  AssistantDataItem: AssistantDataItem | null = null;
  Recommendbuttonlist: { title: string; content: string }[] = [];

  //要先判斷是跟一般模型對話還是跟assistant對話
  chattarget = ''; //assistant or model

  modelname = '';
  assistantNo = ''; //AI助手的編號(自己編的編號)
  assistantid = ''; //AI助手的編號(Key)
  companyid = ''; //公司名稱
  vector_store_id = '';

  containerName = 'quallico'; //blob的container名稱

  init_image = '';
  init_word = '';
  init_meun: InitMenuItem[] = [];
  chatavator = '';
  selectedIcon: string | null = null;
  slogan = '';

  threadid = '';

  selectedFiles: File[] = [];
  // For file picker mode: store selected file ids from fileList
  selectedFileIds: string[] = [];
  imagePreviews: { contentType:string,url: string; uploading: boolean; progress: number,fileid:string ,filename:string}[] = [];

  tools_fileupload = false;
  tools_websearch = false;
  tools_filesearch = false;
  tools_filepicker = false;
  tools_mcpserver = false;

  tools_qrcode = false;

  conponent_callstr = '';

  //動態載入Component用
  @ViewChildren('dynamicComponentContainers', { read: ViewContainerRef })
  dynamicComponentContainers!: QueryList<ViewContainerRef>;

  componentRefs: ComponentRef<any>[] = [];
  cdr = inject(ChangeDetectorRef);

  userMessage!: string;
  assistantReply!: string;

  chatMessages: {
    role: string;
    content: string;
    component?: string | null;
    images?: string[];
  }[] = [];

  isSendingMessage = false;

  meunbuttons: Button[] = []; // 明確設定型別為 Button[]
  actionbuttons: Button[] = []; // 明確設定型別為 Button[]

  //控制是否顯示chat視窗
  showtarget: ShowTarget = 'chat';

  //關鍵字Mapping表,用 getter才會每次要使用的時候，都是最新的值
  get componentMapping(): ComponentMapping[] {
    return this.componentMappings;
  }

  //用來存steam模式下的附件資料
  annotations: Annotation[] = [];

  menuButtons: MenuButton[] = [];

  // 菜單縮小狀態
  isMenuCollapsed = false;

  isDropdownOpen = false;

  isWebSearchActive = false;
  isFileSearchActive = false;

  // 修改数据结构
  vector_store_lists: { id: string; name: string }[] = [
    { id: 'vs_DkkXUXoN0QpK17l1lRzCtvTs', name: '台灣職安衛重點法規資料庫' },
  ];

  // 添加选中数据库ID的变量
  selectedDatabaseId: string = '';

  // 添加选中数据库名称的数组
  selectedDatabases: string[] = [];

  // In your component class:
  departmentId: string = '';


  userroleids:string[] = [];

  // 用於存儲待載入的元件參數
  private pendingComponentKey: string | null = null;

  constructor(
    private authService: AuthService,
    private openAiApiService: OpanaiService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private el: ElementRef,
    private moudleservice: ModuleService,
    private router: Router, // 注入 Router
    private azureBlobService: AzureBlobService,
    private route: ActivatedRoute,
    private menuService: MenuService,
    private componentMappingService: ComponentMappingService,
    private viewContainerRef: ViewContainerRef,
     private http: HttpClient, // 新增 HttpClient
     private i18nService: I18nService,
  ) {}

  // 開啟外部連結
  openExternalLink(url: string): void {
    window.open(url, '_blank');
  }

  async ngOnInit() {
    if (!this.authService.isLoggedIn()) {
      this.authService.redirectToLogin();
      return; // 防止後續代碼執行
    }

    this.companyid = environment.companyid;
    this.assistantNo = this.router.routerState.snapshot.root.queryParams['id'];

    localStorage.setItem('authToken', this.assistantNo);

    if (this.assistantNo == '') {
      //導回到lobby頁面
      this.router.navigate(['/lobby']);
    }

    //取得hotkey
    this.loadComponentMappings();

    //透過API取得使用者所有的角色id(這個要在取得meun資料之前取得)
    await this.getuserroleids();

    //取得assistant資料
    //取得recommentbuttonlist
    // 使用 DataService 取得資料
    this.moudleservice
      .get_assistant_by_no(this.companyid, this.assistantNo)
      .subscribe((items) => {
        this.AssistantDataItem = items;

        if (items?.meuns && items.meuns.length > 0) {
          // 定義回調函數
          const callbacks = {
            go_to_component: (componentName: string, jsonData?: any) => {
              // 載入指定的組件
              if (componentName) {
                this.showConponentOnPage(componentName, jsonData || {});
              }
            },
            go_to_assistant: (menuItem: any) => {  // 改為接收完整的 menuItem 物件
              // 切換到指定的助手，使用新的方法而非導航
              if (menuItem && menuItem.assistantid) {
                // 你可以傳遞整個 menuItem 物件到 showAssistantOnPage
                this.showAssistantOnPage(menuItem);
              }
            },
            gotolobby: this.gotolobby.bind(this),
            clearmsg: this.clearmsg.bind(this),
          };




          // 使用 MenuService 生成按鈕
          this.menuButtons = this.menuService.generateMenuButtons(
            items.meuns,
            callbacks,
            this.userroleids
          );

    //       if (this.menuButtons.length > 0) {
    //   // 例如默認激活第一個按鈕
    //   this.menuButtons[1].isActive = true;
    // }

          this.load_aiassistant(items);

          // 檢查是否有待載入的元件
          this.checkAndLoadPendingComponent();

        } else {
          //取得meunbutton
          this.menuButtons = this.menuService.getSideMenuIcons(
            this.companyid,
            this.vector_store_id,
            {
              gotolobby: this.gotolobby.bind(this),
              toggleVisibility: this.toggleVisibility.bind(this),
              adjustFontSize: this.adjustFontSize.bind(this),
              clearmsg: this.clearmsg.bind(this),
              gotoformlist: this.gotoformlist.bind(this),
              gotoRAGDatabase: this.gotoRAGDatabase.bind(this),
              gotoChat: this.gotoChat.bind(this),
              gotoToDolist: this.gotoToDoList.bind(this),
              gotoReportCenter: this.gotoReportCenter.bind(this),
            }
          );

          this.load_aiassistant();

          // 檢查是否有待載入的元件
          this.checkAndLoadPendingComponent();

        }



      });

      this.route.queryParams.subscribe(params => {
        // Get assistant ID
        const id = params['id'];
        // Get department ID
        this.departmentId = params['dep_id'];
        // Get component key for auto-loading
        const componentKey = params['component'];

        // 如果URL中有component參數，在助手資料載入完成後自動載入該元件
        if (componentKey) {
          this.pendingComponentKey = componentKey;
        }
      });



  }


  getuserroleids(): Promise<void> {
    return new Promise((resolve, reject) => {
      // 使用 AuthService 取得當前使用者資訊
      const userInfo = this.authService.getUserInfo();

      const userid = userInfo.userid;

      if (!userid) {
        console.error('無法取得使用者ID');
        this.userroleids = [];
        resolve(); // 即使沒有 userid 也要 resolve，避免阻塞後續流程
        return;
      }

      // 建立 API URL
      const apiUrl = environment.apiUrl;
      const url = `${apiUrl}/api/departments/user-roles/${this.companyid}/${this.assistantNo}/${userid}`;

      console.log(`載入使用者角色ID，URL: ${url}`);


      // //TODO:目前還沒實作，要補上
      // // 呼叫 API 取得使用者角色ID
      this.http.get<UserRoleApiResponse>(url).subscribe({
        next: (response) => {
          if (response.success && response.data) {
            this.userroleids = response.data;
          } else {
            console.warn('API 回應成功但無資料或失敗:', response);
            this.userroleids = [];
          }
          resolve(); // API 成功完成
        },
        error: (error) => {
          console.error('取得使用者角色ID失敗:', error);
          // 發生錯誤時使用空陣列，避免影響後續功能
          this.userroleids = [];
          resolve(); // 即使發生錯誤也要 resolve，避免阻塞後續流程
        }
      });


    });
  }

  load_aiassistant(assistendataitem?: AssistantDataItem) {

    var assistantitem = null

    if(assistendataitem) {
      assistantitem = assistendataitem.meuns?.find(item => item.type === 'assistant');
    }
    else{
      assistantitem = this.AssistantDataItem;
    }


    this.modelname = this.AssistantDataItem?.title || '';
    this.assistantid = assistantitem?.assistantid || '';

    if (this.assistantid == '') {
      alert('error: assistantid is empty. Redirect to lobby page');
      //導回到lobby頁面
      // this.router.navigate(['/lobby']);
    } else {
      this.init_image =
        assistantitem?.Initialized?.init_image || '';
      this.init_word = assistantitem?.Initialized?.init_word || '';
      this.init_meun = assistantitem?.Initialized?.init_meun || [];
      this.chatavator =
        assistantitem?.Initialized?.chatavator || '';

      this.assistantid = assistantitem?.assistantid || '';
      this.vector_store_id = assistantitem?.vector_store_id || '';
      this.vector_store_lists =
        assistantitem?.vector_store_lists || [];

      //檢查可以使用那些tools
      var tools = assistantitem?.tools || [];

      if (tools.length > 0) {
        tools.forEach((tool) => {
          if (tool == 'fileupload') {
            this.tools_fileupload = true;
          }

          if (tool == 'websearch') {
            this.tools_websearch = true;
          }

          if (tool == 'filesearch') {
            this.tools_filesearch = true;
          }


          if (tool == 'filepicker') {
            this.tools_filepicker = true;
          }

          if (tool == 'mcpserver') {
            this.tools_mcpserver = true;
          }

        });
      }

      if (this.assistantid.startsWith('asst')) {
        this.chattarget = 'assistant';
      } else {
        this.chattarget = 'model';
      }
    }
  }

  private loadComponentMappings(): void {
    this.componentMappingService
      .getComponentMappings()
      .subscribe((mappings) => {
        this.componentMappings = mappings;
      });
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe((params) => {
      const message = params['message'];
      const chattarget = params['chattarget'];

      if (message && chattarget) {
        this.chattarget = chattarget;
        this.chatwithAI(message, message);
      }
    });
  }

  menubuttonclick(title: string, content: string, functionname: string = '') {
    // this.showintroduction = false;
    // this.showchat = true;

    if (functionname != '') {
      const func = (this as any)[functionname];
      if (typeof func === 'function') {
        func.call(this); // 確保 this 的指向正確
      } else {
        console.error('找不到對應的函式：' + functionname);
      }
    } else {
      //content有值才顯示在對話視窗
      if (content) {
        //跟AI對話
        this.chatwithAI(title, content, functionname);
      } else {
        console.log('找不到對應的內容');
      }
    }
  }

  //還沒用到的功能

  CallsimulateExamComponent() {
    this.isSendingMessage = true; // 開始 Loading 狀態

    var jsonobject: any;

    //只有幾堂課，是從AI產生
    if (
      this.modelname == '高壓氣體供應及消費作業主管' ||
      this.modelname == '高壓氣體製造安全作業主管'
    ) {
      jsonobject = {
        component: 'simulateExamComponent',
        classname: this.modelname,
        totalminutes: 10,
        testnumbers: 10,
        fromdatabase: false,
      };
    } else {
      jsonobject = {
        component: 'simulateExamComponent',
        classname: this.modelname,
        totalminutes: 100,
        testnumbers: 80,
        fromdatabase: true,
      };
    }

    try {
      this.addNewConponentMessage('simulateExamComponent', jsonobject);
    } catch (error) {
      this.isSendingMessage = false; // 開始 Loading 狀態
    } finally {
      this.isSendingMessage = false; // 開始 Loading 狀態
    }
  }

  chatwithAI(title: string, message?: string, component?: string) {
    if (this.isSendingMessage) return; // 防止重複送出
    if (this.userMessage == '' && title == '') return; // 防止空白訊息

    this.actionbuttons = []; // 清空按鈕
    this.conponent_callstr = ''; //清空判斷是否為Component用的str

    // console.log(this.userMessage);

    this.isSendingMessage = true; // 開始 Loading 狀態

    if (!message) {
      message = title;
    }

    var userMessage = message;

    //先看看是不是有中關鍵字列表
    const mapping = this.componentMapping.find(
      (map) => map.keyword === userMessage
    );

    if (mapping) {
      this.loadcomponent(mapping);
    } else {
      // console.log('開始:', this.isSendingMessage);

      //如果沒有mapping到關鍵字，先看是不是送物件過來
      this.chat_with_respones_api(title, message, component);

    }

    this.imagePreviews = [];
  }

  loadcomponent(mapping: any) {
    try {
      this.addNewConponentMessage(mapping.component, mapping.jsondata);
    } catch (error) {
      // 如果解析失敗，調用方法並只傳遞 component
      console.log('傳送到addNewConponentMessage失敗');
    } finally {
      this.finishLoading();
    }
  }

  //最新的呼叫OpenAI的方法
  chat_with_respones_api(title: string, message: string, component?: string) {
    var toolname = [];
    var vector_store_id = '';
    let file_ids: string[] = [];

    if (this.isWebSearchActive) {
      toolname.push('web_search');
    } else if (this.isFileSearchActive) {
      toolname.push('file_search');

      if (this.selectedDatabaseId == '') {
        alert('請先選擇要搜尋的知識庫');
        this.finishLoading();
        return;
      } else {
        vector_store_id = this.selectedDatabases[0];
      }
    }

    if (this.tools_mcpserver) {
      toolname.push('mcp_server');
    }

    this.annotations = [];

    const userComponent = component || '';

    // console.log('this.imagePreviews', this.imagePreviews);

    if (title !== '') {
      // 修改從 imagePreviews 獲取實際圖片的邏輯，僅保留 contentType 為 image 的項目
      var showimglist = this.imagePreviews.map((preview) => preview.url);

      // **加入使用者訊息，包含圖片**
      this.chatMessages.push({
        role: 'user',
        content: title,
        component: userComponent,
        images: showimglist, // 讓 Assistant 可接收圖片
      });

      this.userMessage = '';
    } else {
      return;
    }

    // **新增 AI 回應的佔位訊息**
    const assistantMessage = {
      role: 'assistant',
      content: '',
      component: '',
    };

    //取得 file_ids

    // 一個來源是filepicker
    if (this.isFilePickerActive && Array.isArray(this.selectedFileIds)) {
      file_ids = [...file_ids, ...this.selectedFileIds];
    }

    //一個來源是直接用附件上傳
    var uploadfilelist = this.imagePreviews.filter(
      (preview) => preview.contentType !== 'image'
    );

    if (uploadfilelist.length > 0) {
      const documentFileIds = uploadfilelist
        .filter((file) => file.fileid && file.fileid.trim() !== '')
        .map((file) => file.fileid);

      // 將文件 ID 加入到 file_ids 陣列中
      if (documentFileIds.length > 0) {
        // 將文件 ID 合併到已有的 file_ids 陣列中
        file_ids = [...file_ids, ...documentFileIds];

      }
    }

    // console.log('file_ids:', file_ids);

    var imglist = this.imagePreviews
      .filter((preview) => preview.contentType === 'image')
      .map((preview) => preview.url);

    this.chatMessages.push(assistantMessage);
    const assistantIndex = this.chatMessages.length - 1; // 取得剛剛 push 的 AI 訊息索引


    var model_version = "gpt-4o-mini"; //預設使用gpt-4o-mini

    if(file_ids.length > 0 || imglist.length > 0) {
      model_version = "o4-mini"; //如果有上傳檔案或圖片，就使用o4mini
    }


    // console.log("toolname",toolname);


    this.openAiApiService
      .chatwithOpenAIWithSteam(
        message,
        this.assistantNo,
        this.threadid,
        this.companyid,
        toolname,
        vector_store_id,
        imglist,
        [], //this.selectedFiles, 現在上傳都會先放到azure blob上，然後傳網址，不會直接傳檔案
        file_ids,
        model_version
      )
      .subscribe({
        next: (data) => {
          this.appendToChatMessages(assistantIndex, data);
        },
        error: (err) => {
          console.error('發生錯誤:', err);
        },
        complete: () => {
          //有呼叫function
          if (this.conponent_callstr != '') {
            try {
              if (this.chatMessages[assistantIndex].content == '') {
                this.chatMessages.splice(assistantIndex, 1);
              }
              this.HandleConponentString(this.conponent_callstr);
            } catch (error) {
              this.chatMessages[assistantIndex].content +=
                this.conponent_callstr;
            }
          }

          // if (this.annotations.length > 0) {
          //   this.appendAnotations(assistantIndex, this.annotations);
          // }

          this.finishLoading();
        },
      });
  }

  appendToChatMessages(assistantIndex: number, data: string) {
    // data是個字串，並且要解析成物件
    const jsonArray = JSON.parse(data); // 解析成陣列

    if (jsonArray) {
      if (jsonArray.type == 'response.output_text.delta' && jsonArray.delta) {
        if (this.conponent_callstr != '') {
          this.conponent_callstr += jsonArray.delta;
          return;
        } else {
          if (
            typeof jsonArray.delta === 'string' &&
            jsonArray.delta.trim().startsWith('{') &&
            this.conponent_callstr == ''
          ) {
            this.conponent_callstr += jsonArray.delta;
            return;
          }
        }

        this.chatMessages[assistantIndex].content += jsonArray.delta;
      }

      if (jsonArray.type == 'response.completed' && jsonArray.response) {
        this.threadid = jsonArray.response.id;
      }

    }
  }


  HandleConponentString(componentString: string) {
    try {
      var clearstr = componentString.replace('json', '').replace('```', '');

      const jsonObject = JSON.parse(clearstr);
      // console.log('提取到的 JSON 对象:', jsonObject);

      var componentname = jsonObject.component;

      //將其他的屬性放到陣列中
      this.addNewConponentMessage(componentname, jsonObject);
    } catch (error) {
      console.error('解析 JSON 出错:', error);
    } finally {
      this.finishLoading();
    }
  }


  loadComponents(componentKey: string, jsondata: string = ''): void {
    // console.log('componentKey:', componentKey);
    // console.log("jsondata",jsondata);

    //資料變更後重新渲染元件
    const containers = this.dynamicComponentContainers.toArray();
    const lastContainerIndex = containers.length - 1;
    //找到最後一個容器
    const container = containers[lastContainerIndex];

    const componentClass = COMPONENT_MAP[componentKey];

    if (!container) {
      console.error(`找不到對應的容器: index ${lastContainerIndex}`);
      return;
    }

    const componentRef: ComponentRef<any> =
      container.createComponent(componentClass);

    //將回傳的參數，送進去component
    let parsedData: any = jsondata;
    if (typeof jsondata === 'string' && jsondata != '') {
      try {
        parsedData = JSON.parse(jsondata);
      } catch (error) {
        console.error('無法解析 jsondata:', error);
      }
    }

    // 將回傳的參數，送進去 component
    if (parsedData != '') {
      Object.keys(parsedData).forEach((key) => {
        const value = parsedData[key as keyof typeof parsedData];
        // console.log(`Key: ${key}, Value: ${value}`);
        if (key !== 'component') {
          componentRef.instance[key] = value;
        }
      });
    }

    //針對特別的component做處理，設定Input值

    if (componentKey === 'filedownloader') {
      componentRef.instance.containerName = this.containerName;
    }

    //設定Output值 => 每個元件有的output不一樣，要先判斷是否有，才做綁定
    if (
      'chatwithAI' in componentRef.instance &&
      componentRef.instance.chatwithAI instanceof EventEmitter
    ) {
      componentRef.instance.chatwithAI.subscribe((data: any) => {
        this.chatwithAI(data);
      });
    }

    if (
      'Showlist' in componentRef.instance &&
      componentRef.instance.Showlist instanceof EventEmitter
    ) {
      componentRef.instance.Showlist.subscribe((data: any) => {
        this.Showlist(data);
      });
    }

    if (
      'fillform' in componentRef.instance &&
      componentRef.instance.fillform instanceof EventEmitter
    ) {
      componentRef.instance.fillform.subscribe((data: any) => {
        this.fillform(data);
      });
    }

    this.componentRefs.push(componentRef); // 儲存子元件的引用
  }

  ngOnDestroy(): void {
    // 清除組件參考，避免記憶體洩漏
    for (const componentRef of this.componentRefs) {
      if (componentRef) {
        componentRef.destroy();
      }
    }
  }

  contentfransfer(content: string): string {
    // // 替換以數字開頭的選項行，加上 `<a>` 標籤
    // content = content.replace(/^\(\d+\)\s.*$/gm, (match) => {
    //   return `<a class='canclick' href="#" onclick="return false;" data-value='${match}'>${match}</a>`;
    // });

    // // 匹配並替換被【】包含的所有文字，去除【】符號
    // content = content.replace(/【([^【】]+)】/g, (match, p1) => {
    //   return `<a class='canclick' href="#" onclick="return false;" data-value='${p1}'>${p1}</a>`;
    // });

    return content;
  }

  setInputValue(value: string) {
    this.userMessage = value;
  }

  Showlist(formname: string) {
    var componentKey = 'showlistComponent';
    var jsondata = {
      component: 'showlistComponent',
      formName: formname,
    };

    this.addNewConponentMessage(componentKey, jsondata);
  }

  fillform(formname: string) {
    var componentKey = 'DynamicFormComponent';
    var jsondata = {
      component: 'DynamicFormComponent',
      formName: formname,
      assistantid: this.assistantid,
      assistantname: this.modelname,
    };

    this.addNewConponentMessage(componentKey, jsondata);
  }

  // 捕捉按鍵事件
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // 阻止默認的換行行為
      this.chatwithAI(this.userMessage);
      this.userMessage = ''; // 清空輸入框
    }
  }

  closeDiv() {
    this.showintroduction = true;
    // this.showchat = true;
    // this.showrecommentlist = false;

    this.chatMessages = [];

    //清空threadid
    this.threadid = '';
  }

  onIconClick(icon: string) {
    this.selectedIcon = icon; // 設定當前選取的圖示

    if (icon == 'sad') {
      this.slogan = '(明日は明日の風が吹く)';
    } else {
      this.slogan = '';
    }
  }

  //導頁到檔案中心
  gotofilecenter() {
    var jsonstr = {
      component: 'FilebankComponent',
      vector_store_id: this.vector_store_id,
    };

    this.addNewConponentMessage('FilebankComponent', jsonstr);
  }

  /**
   * 動態加載元件並插入到 chatMessages
   */
  addNewConponentMessage(componentKey: string, jsondata: any = {}): void {
    const componentClass = COMPONENT_MAP[componentKey];

    //

    if (!componentClass) {
      console.error(`找不到對應的元件: ${componentKey}`);
      return;
    }

    //將元件加入到 chatMessages
    this.chatMessages.push({
      role: 'assistant',
      content: '',
      component: componentKey,
    });

    // console.log('chatMessages:', this.chatMessages);

    // 通知 Angular 檢測變更並更新 DOM
    this.cdr.detectChanges();

    // 延遲執行查詢和事件綁定，確保 DOM 已經完全更新，否則會找不到元素
    // render元件
    setTimeout(() => {
      this.loadComponents(componentKey, jsondata);
    }, 0);
  }

// 將元件顯示在頁面上，而不是對話中
showConponentOnPage(componentKey: string, jsondata: any = {}): void {
  // 移除 alert，它已不再需要用於測試
  // alert("showConponentOnPage"+componentKey);

  // 設置目標區域顯示為頁面，隱藏聊天區域
  this.showtarget = 'page';

  // 更新選單按鈕的活躍狀態
  this.updateMenuActiveState(componentKey);

  // 更新 URL，添加 component 參數，顯示當前載入的元件
  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: { component: componentKey },
    queryParamsHandling: 'merge', // 保留其他現有的查詢參數
    skipLocationChange: false, // 確保 URL 更新
  });

  // 通知 Angular 立即進行變更檢測，確保 DOM 更新
  this.cdr.detectChanges();

  // 使用 setTimeout 確保在 DOM 更新後執行元件創建
  setTimeout(() => {
    // 獲取要創建的元件類
    const componentClass = COMPONENT_MAP[componentKey];

    if (!componentClass) {
      console.error(`找不到對應的元件: ${componentKey}`);
      return;
    }

    // 獲取頁面容器的元素引用
    const pageContainer = document.getElementById('pagediv');
    if (!pageContainer) {
      console.error('找不到頁面容器元素');
      return;
    }

    // 清空頁面容器
    pageContainer.innerHTML = '';

    // 創建和插入元件
    const viewContainerRef = this.viewContainerRef;
    const componentRef = viewContainerRef.createComponent(componentClass);

    // 傳遞數據到元件，使用類型斷言解決 TypeScript 錯誤
    if (jsondata && Object.keys(jsondata).length > 0) {
      Object.keys(jsondata).forEach(key => {
        // 使用索引簽名訪問屬性，解決類型錯誤
        (componentRef.instance as any)[key] = jsondata[key];
      });
    }

    // 將元件的原生元素附加到頁面容器
    pageContainer.appendChild(componentRef.location.nativeElement);

    // 額外的變更檢測以確保視圖完全更新
    this.cdr.detectChanges();
  }, 0);  // 使用 0 毫秒的 setTimeout 讓 Angular 先完成 DOM 更新
}

// 顯示 AI 助手於頁面上
showAssistantOnPage(menuItem: any): void {

  // 設置目標區域顯示為助手
  this.showtarget = 'chat';

  // 如果有完整的 menuItem 物件，可以直接使用其中的資料
  if (menuItem) {
    // 更新助手相關資料
    this.assistantid = menuItem.assistantid || '';
    this.vector_store_id = menuItem.vector_store_id || '';
    this.vector_store_lists = menuItem.vector_store_lists || [];

    // 更新初始化資料（如果有）
    if (menuItem.Initialized) {
      this.init_image = menuItem.Initialized.init_image || '';
      this.init_word = menuItem.Initialized.init_word || '';
      this.init_meun = menuItem.Initialized.init_meun || [];
      this.chatavator = menuItem.Initialized.chatavator || '';
    }

    // 檢查可以使用的工具
    const tools = menuItem.tools || [];
    this.tools_fileupload = tools.includes('fileupload');
    this.tools_websearch = tools.includes('websearch');
    this.tools_filesearch = tools.includes('filesearch');

    // 重設目標對話對象
    this.chattarget = menuItem.assistantid?.startsWith('asst')
      ? 'assistant'
      : 'model';

    // 顯示初始介紹畫面
    this.showintroduction = true;

    // 通知變更檢測
    this.cdr.detectChanges();

  }
  else{
    alert('menuItem is undefined');
  }

}

  onValueSubmitted(data: any, index: number) {
    // console.log('來自子元件的資料:', data);
    // console.log('該元件在 chatMessages 的索引:', index);
    // 可以將資料寫入資料庫或進一步處理
  }

  // 自動調整輸入框高度
  autoResize(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto'; // 先重置高度，避免疊加
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  // 當用戶選擇文件時
  async onFilesSelected(event: Event) {


    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];

        const isImage = file.type.startsWith('image/');
        const isPdf = file.type === 'application/pdf';
        const isWord = file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

        if (isImage) {
      this.handleImageFile(file);
    } else if (isPdf || isWord) {
      this.handleDocumentFile(file);
    } else {
      console.warn('不支援的檔案類型:', file.type);
    }

      }
    }
  }

  private async handleImageFile(file: File): Promise<void> {
    // 生成本地預覽 URL
    const localPreviewUrl = URL.createObjectURL(file);
    this.imagePreviews.push({
      contentType: "image",
      url: localPreviewUrl,
      uploading: true,
      progress: 0,
      fileid:"",
      filename:"",
    });
    this.selectedFiles.push(file);

    // 模擬上傳進度
    const index = this.imagePreviews.length - 1;

    try {
      // 上傳檔案到 Azure Blob Storage 並取得 URL
      const fileUrl = await this.azureBlobService.uploadFile(
        file,
        this.companyid,
        'public'
      );
      // console.log('Uploaded file URL:', fileUrl);

      // 上傳成功後更新預覽的 URL 並標記為上傳完成
      //先不處理uploading的動畫，改成Loading完成後，可以點擊
      this.imagePreviews[index].url = fileUrl;
      this.imagePreviews[index].uploading = false;
    } catch (error) {
      console.error('Error uploading file:', error);
      this.imagePreviews[index].uploading = false;
      alert('檔案上傳失敗，請重試。');
    }
  }

private handleDocumentFile(file: File): void {

  console.log('處理文件檔案:', file);
  // 上傳中狀態
  const filePreview = {
    fileid: "",
    url: '', // 文件檔沒有預覽圖
    file: file,
    uploading: true,
    filename: file.name,
    contentType: file.type,
    progress: 0
  };

  // 設定文件預覽圖示
  if (file.type === 'application/pdf') {
    filePreview.url = 'assets/images/shared/pdf-icon.png';
  } else {
    filePreview.url = 'assets/images/shared/doc-icon.png';
  }

  // 添加到預覽列表
  this.imagePreviews.push(filePreview);
  const previewIndex = this.imagePreviews.length - 1;

  // 創建 FormData 用於檔案上傳
  const formData = new FormData();
  formData.append('file', file);

  // 呼叫 API 上傳檔案到 OpenAI
  const apiUrl = `${environment.apiUrl}/api/vectordb/uploadsinglefile`;

  // 使用 HttpClient 進行檔案上傳
  this.http.post(apiUrl, formData).subscribe({
    next: (response: any) => {
      if (response.success && response.file_id) {
        // 更新預覽中的文件 ID 和上傳狀態
        this.imagePreviews[previewIndex].fileid = response.file_id;
        this.imagePreviews[previewIndex].uploading = false;
        this.imagePreviews[previewIndex].progress = 100;
        this.imagePreviews[previewIndex].filename = file.name;

        console.log(`文件已上傳到 OpenAI，檔案 ID：${response.file_id}`);
      } else {
        console.error('上傳文件失敗：', response);
        this.handleDocumentUploadError(previewIndex);
      }
    },
    error: (error) => {
      console.error('上傳文件出錯：', error);
      this.handleDocumentUploadError(previewIndex);
    }
  });
}

// 處理文件上傳錯誤
private handleDocumentUploadError(previewIndex: number): void {
  if (previewIndex >= 0 && previewIndex < this.imagePreviews.length) {
    this.imagePreviews[previewIndex].uploading = false;

    // 顯示錯誤圖示
    this.imagePreviews[previewIndex].url = 'assets/images/shared/error-icon.png';

    // 可選：顯示錯誤訊息或允許重試上傳
    // this.showErrorNotification('檔案上傳失敗，請重試');
  }
}

  // 觸發檔案上傳
  triggerFileUpload() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  // 移除指定索引的圖片預覽
  removeImage(index: number) {
    this.imagePreviews.splice(index, 1);
    this.selectedFiles.splice(index, 1);
  }

  websearch(): void {
    // 互斥：關閉其他兩個 active 狀態
    if (!this.isWebSearchActive) {
      this.isFileSearchActive = false;
      this.isFilePickerActive = false;
    }
    this.isWebSearchActive = !this.isWebSearchActive;

    // 如果搜索模式激活，可以调整文本框的placeholder
    if (this.isWebSearchActive) {
      // 切換到 websearch 時清除 file picker 狀態
      this.clearFilePickerState();
      // 可选: 更改placeholder
      // 例如: document.querySelector('textarea').setAttribute('placeholder', '输入搜索内容...');

      // 如果需要，聚焦到文本框
      setTimeout(() => {
        const textarea = document.querySelector('textarea');
        if (textarea) {
          textarea.focus();
        }
      }, 0);
    } else {
      // 恢复原始placeholder
      // 例如: document.querySelector('textarea').setAttribute('placeholder', 'Ask anything');
    }
  }

  filesearch(): void {
    // 互斥：關閉其他兩個 active 狀態
    if (!this.isFileSearchActive) {
      this.isWebSearchActive = false;
      this.isFilePickerActive = false;
    }
    this.isFileSearchActive = !this.isFileSearchActive;

    // 如果搜索模式激活，可以调整文本框的placeholder
    if (this.isFileSearchActive) {
      // 切換到 filesearch 時清除 file picker 狀態
      this.clearFilePickerState();
      // 可选: 更改placeholder
      // 例如: document.querySelector('textarea').setAttribute('placeholder', '输入搜索内容...');
      // this.selectDatabase(this.availableDatabases[0].id); // 默认选择第一个数据库

      // 如果需要，聚焦到文本框
      setTimeout(() => {
        const textarea = document.querySelector('textarea');
        if (textarea) {
          textarea.focus();
        }
      }, 0);
    } else {
      this.selectedDatabases = [];
      // 恢复原始placeholder
      // 例如: document.querySelector('textarea').setAttribute('placeholder', 'Ask anything');
    }
  }

  onQRCodeUpload(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          if (context) {
            // 壓縮圖片，限制寬度和高度
            const maxDimension = 500; // 最大邊長，根據需求可調整
            const scale = Math.min(
              maxDimension / img.width,
              maxDimension / img.height
            );
            canvas.width = img.width * scale;
            canvas.height = img.height * scale;

            context.drawImage(img, 0, 0, canvas.width, canvas.height);

            // 獲取圖片像素數據並解析 QR Code
            const imageData = context.getImageData(
              0,
              0,
              canvas.width,
              canvas.height
            );
            const qrCode = jsQR(imageData.data, canvas.width, canvas.height);

            if (qrCode) {
              const text = qrCode.data;

              if (text.startsWith('QRData')) {
                const result = text.replace(/^QRData[:：]/, ''); // 清除前綴
                this.chatwithAI(result);
              } else {
                alert('內容或格式不符，無法解析');
              }
            } else {
              alert('未檢測到有效的 QR Code');
            }
          }
        };
        if (reader.result) {
          img.src = reader.result.toString();
        }
      };
      reader.readAsDataURL(file);
    }
  }

  currentFontSize: number = 16; // 預設字體大小

  adjustFontSize(action: 'increase' | 'decrease') {
    const chatDiv = document.getElementById('chatdiv');
    if (chatDiv) {
      if (action === 'increase' && this.currentFontSize < 32) {
        this.currentFontSize += 2;
      } else if (action === 'decrease' && this.currentFontSize > 16) {
        this.currentFontSize -= 2;
      }
      chatDiv.style.fontSize = `${this.currentFontSize}px`;
    }
  }

  clearmsg() {
    this.chatMessages = [];
  }

  gotolobby() {
    if (this.departmentId) {
      this.router.navigate(['/lobby'], { queryParams: { dep_id: this.departmentId } });
    } else {
      this.router.navigate(['/lobby']);
    }
  }

  // 新增返回部門頁面的方法
  backToDepartment() {
    if (this.departmentId) {
      this.router.navigate(['/lobby'], { queryParams: { dep_id: this.departmentId } });
    } else {
      this.router.navigate(['/lobby']);
    }
  }

  toggleVisibility() {
    this.showintroduction = !this.showintroduction;
    // 這裡填入隱藏/顯示的邏輯
  }

  finishLoading() {
    this.userMessage = '';
    this.isSendingMessage = false;
    this.scrollToBottom();
  }

  // 滾动到对话视窗底部
  scrollToBottom(): void {
    const chatContainer = document.getElementById('chat-container');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }

  gotoChat(): void {
    this.showtarget = 'chat';
  }

  gotoRAGDatabase(): void {
    this.gotofilecenter();
  }

  gotoToDoList(): void {
    alert('Go To To Do List');
    // this.showtarget = "todo";
  }

  gotoReportCenter(): void {
    alert('Go To Repoer Center');
    //  this.showtarget = "report";
  }

  gotoformlist(): void {
    alert('Go To Form Center');
    // alert("gotoformlist");

    // this.showtarget = "form";
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // 选择数据库的方法 - 单选模式
  selectDatabase(dbId: string): void {
    // 如果点击当前已选中的数据库，则取消选择
    if (this.selectedDatabaseId === dbId) {
      this.selectedDatabaseId = '';
    } else {
      // 否则设置为新选择的数据库
      this.selectedDatabaseId = dbId;
    }

    // 更新所选数据库数组（用于标签显示）
    if (this.selectedDatabaseId === '') {
      this.selectedDatabases = [];
    } else {
      const selectedDb = this.vector_store_lists.find(
        (db) => db.id === this.selectedDatabaseId
      );
      if (selectedDb) {
        this.selectedDatabases = [selectedDb.id];
      }
    }

    // 自动聚焦到文本框
    setTimeout(() => {
      const textarea = document.querySelector('.textarea-container textarea');
      if (textarea) {
        (textarea as HTMLTextAreaElement).focus();
      }
    }, 0);
  }

  handleMenuButtonClick(clickedButton: MenuButton) {
    // 先保存原始動作函數
    const originalAction = clickedButton.action;

    // 重置所有按鈕狀態
    this.menuButtons.forEach(btn => btn.isActive = false);

    // 設置點擊的按鈕為活躍狀態
    clickedButton.isActive = true;

    // 執行原始動作
    if (typeof originalAction === 'function') {
      originalAction();
    }
  }

  // 切換菜單縮小狀態
  toggleMenuCollapse() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    // 保存用戶偏好設定
    this.saveMenuPreferences();
  }

  // 載入菜單偏好設定
  private loadMenuPreferences() {
    const saved = localStorage.getItem('menuCollapsed');
    if (saved !== null) {
      this.isMenuCollapsed = JSON.parse(saved);
    }
  }

  // 保存菜單偏好設定
  private saveMenuPreferences() {
    localStorage.setItem('menuCollapsed', JSON.stringify(this.isMenuCollapsed));
  }

  // 檢查並載入待處理的元件
  private checkAndLoadPendingComponent(): void {
    if (this.pendingComponentKey && this.AssistantDataItem) {
      // 使用 setTimeout 確保 DOM 更新完成
      setTimeout(() => {
        if (this.pendingComponentKey) {
          this.showConponentOnPage(this.pendingComponentKey, {});
          this.pendingComponentKey = null; // 清除待處理的元件
        }
      }, 100);
    }
  }

  // 根據 componentKey 更新選單按鈕的活躍狀態
  private updateMenuActiveState(componentKey: string): void {
    if (!this.menuButtons || this.menuButtons.length === 0) {
      return;
    }

    // 重置所有按鈕的活躍狀態
    this.menuButtons.forEach(btn => btn.isActive = false);

    // 透過 componentKey 直接找到對應的按鈕
    const matchingButton = this.menuButtons.find(btn => btn.componentKey === componentKey);

    if (matchingButton) {
      matchingButton.isActive = true;
      console.log('Menu button activated for component:', componentKey);
    }
  }
}
